import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { CatalogPage } from './components/CatalogPage';
import MiddlewareEventBus from '../react/common/lib/MiddlewareEventBus';
import IReactEvent from '../interfaces/article-list/IReactEvent';
import ProductList from './components/catalog-page-content/product-list/ProductList';
import { SearchPageEvent } from '../shop-ui/components/search-page/events/searchPageEvent';
import FilterStateService from '../shop-ui/components/search-page/services/FilterStateService';
import { API_URL, emptyCatalogPageState, FILTER_TYPE_MAPPING } from './constants';
import {
    IApiQueryData,
    ISearchPageContentDataUpdatedPayload,
    ISearchResponse
} from '../shop-ui/components/search-page/interfaces';
import { IProductItem } from '../shop-ui/interfaces';
import Breadcrumb from '../shop-ui/components/search-page/components/breadcrumb/Breadcrumb';
import { isCompactModeApplyForContext, isNavigationFilterApplyForContext } from './includes/helper/context-helper';
import { HELMET_BUYER_GUIDE_URL_DATA_ATTRIBUTE } from '../helmet-buyer-guide-page/constants';
import { HelmetBuyerGuideLanding } from '../shop-ui/components/HelmetBuyerGuideLanding';
import ProductWishListHandler from 'PyzShopUi/scripts/product-wish-list/ProductWishListHandler';
import { productImageLocator } from 'PyzShopUi/scripts/shop-ui/includes/product-image-locator';
import { createCatalogPageStateWithInitResponse } from 'PyzShopUi/scripts/catalog-page/includes/helper/state-helper';
import { CatalogPageEvent } from 'PyzShopUi/scripts/catalog-page/events/catalogPageEvent';
import { VIEW_OPTION_LIST } from 'PyzShopUi/scripts/constants/bike-db';
import { ListNameContext } from 'PyzShopUi/scripts/shop-ui/components/product-item/ProductItemListNameContext'

(window as any).global = window;

const CATALOG_LIST_NAME = 'Catalog'

export default class CatalogPageHandler {
    public static init = (): void => {
        const catalogPageElement: HTMLElement = document.querySelector('.catalog-page-client-init');
        if (!catalogPageElement) {
            return;
        }

        CatalogPageHandler.renderProductWishListIcon();

        const elementDataSet = catalogPageElement.dataset;

        const isProductListRenderOnInit: boolean = elementDataSet.productListRenderOnInit === 'true';
        const defaultParameter: IApiQueryData = JSON.parse(elementDataSet.defaultParameters);

        const filterStateService = new FilterStateService(FILTER_TYPE_MAPPING);
        const isCompactMode: boolean = isCompactModeApplyForContext(defaultParameter);

        let catalogPageState;
        if (isProductListRenderOnInit) {
            catalogPageState = emptyCatalogPageState;
        } else {
            const initResponse: ISearchResponse = JSON.parse(elementDataSet.initResponse);
            catalogPageState = createCatalogPageStateWithInitResponse(initResponse, defaultParameter, filterStateService);
        }

        MiddlewareEventBus.getInstance().subscribe((event: IReactEvent<ISearchPageContentDataUpdatedPayload>) => {
            switch (event.type) {
                case CatalogPageEvent.CATALOG_PAGE_CONTENT_DATA_INIT:
                    CatalogPageHandler.handleGTMEvent(event);
                    CatalogPageHandler.renderMyBikeHint(event);

                    if (event.payload.viewMode === VIEW_OPTION_LIST) {
                        CatalogPageHandler.renderCatalogProductList(
                            event,
                            isCompactMode
                        );
                    }

                    break;
                case SearchPageEvent.SEARCH_PAGE_CONTENT_DATA_UPDATED:
                    CatalogPageHandler.handleGTMEvent(event);
                    CatalogPageHandler.renderBreadcrumb(event);
                    CatalogPageHandler.renderCatalogProductList(
                        event,
                        isCompactMode
                    );
                    CatalogPageHandler.renderHelmetBuyerGuideLanding(
                        isNavigationFilterApplyForContext(defaultParameter),
                        event
                    );
                    CatalogPageHandler.renderMyBikeHint(event);

                    break;
                default:
                    break;
            }
        });

        ReactDOM.render(
            <CatalogPage
                apiUrl={API_URL}
                defaultParameter={defaultParameter}
                filterStateService={filterStateService}
                isCompactMode={isCompactMode}
                initialState={catalogPageState}
                isStateNeedInitiated={isProductListRenderOnInit}
            />,
            catalogPageElement,
        );
    };

    public static handleGTMEvent(event: IReactEvent<ISearchPageContentDataUpdatedPayload>) {
        const { extraInformation } = event.payload;

        const gtmLoadEvents = extraInformation?.gtm;

        if (!window.hasOwnProperty('Louis') || !gtmLoadEvents) {
            return;
        }

        gtmLoadEvents.forEach(gtmLoadEvent => {
            window.Louis.Events.handleGTMEvent(gtmLoadEvent);
        });
    }

    public static renderBreadcrumb(event: IReactEvent<ISearchPageContentDataUpdatedPayload>) {
        const { breadcrumb } = event.payload;

        if (!breadcrumb || !breadcrumb.length) {
            return;
        }

        ReactDOM.render(
            <Breadcrumb
                breadcrumb={breadcrumb}
            />,
            document.querySelector('.breadcrumb-navigation'),
        );
    }

    public static renderCatalogProductList(
        event: IReactEvent<ISearchPageContentDataUpdatedPayload>,
        isCompactMode: boolean,
    ) {
        const {
            viewMode,
            searchResultItems,
            isSearchPageLoading,
            storeConfig,
            hasActiveFilter,
        } = event.payload;

        ReactDOM.render(
            <ListNameContext.Provider value={`${CATALOG_LIST_NAME}`}>
                <ProductList
                    products={searchResultItems as IProductItem[]}
                    isProgressing={isSearchPageLoading}
                    storeConfig={storeConfig}
                    viewMode={viewMode}
                    hasActiveFilter={hasActiveFilter}
                    isCompactMode={isCompactMode}
                />
            </ListNameContext.Provider>,
            document.querySelector('.product-list'),
        );
    }

    public static renderHelmetBuyerGuideLanding(
        isNavigationFilterExist: boolean,
        event: IReactEvent<ISearchPageContentDataUpdatedPayload>
    ) {
        if (isNavigationFilterExist) {
            return;
        }

        const { categoryKey } = event.payload;

        const teaserElement = document.querySelector('.hbg-teaser-init');
        if (teaserElement === null) {
            return;
        }

        const helmetBuyerGuidePageLink = teaserElement.getAttribute(HELMET_BUYER_GUIDE_URL_DATA_ATTRIBUTE) || '';

        ReactDOM.render(
            <HelmetBuyerGuideLanding
                categoryKey={categoryKey}
                helmetBuyerGuidePageLink={helmetBuyerGuidePageLink}
            />,
            teaserElement
        );
    }

    private static renderProductWishListIcon() {
        const searchItemsResultElement: HTMLElement = document.querySelector('.page-layout-search-items-result');
        if (!searchItemsResultElement) {
            return;
        }

        ProductWishListHandler.renderIcons(searchItemsResultElement, productImageLocator);
    };

    private static renderMyBikeHint(event: IReactEvent<ISearchPageContentDataUpdatedPayload>) {
        const myBikeHintElement = document.querySelector('.my-bike-hint');
        if (myBikeHintElement === null || event.payload.isSearchPageLoading) {
            return;
        }

        ReactDOM.render(
            <div dangerouslySetInnerHTML={
                { __html: event.payload?.extraInformation?.myBikeHint }
            }>
            </div>,
            myBikeHintElement
        );
    }
}
